import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/', label: '首页' },
  { to: '/dramas', label: '剧集库' },
  { to: '/calendar', label: '追剧日历' },
  { to: '/about', label: '关于我们' },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 backdrop-blur-md'
          : 'border-transparent bg-background-50'
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-content items-center justify-between gap-4 px-4 md:h-20 md:px-6">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-xl" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
              爆料短剧
            </span>
            <span className="hidden text-[11px] tracking-[0.2em] text-foreground-500 sm:block">
              更新顺序 · 追剧日历
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `cursor-pointer rounded-md px-4 py-2 text-sm transition-colors duration-200 ${
                  isActive
                    ? 'bg-primary-50 font-medium text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/calendar"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors duration-200 hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-calendar-2-line" aria-hidden="true" />
            今日更新
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav aria-label="移动端导航" className="mx-auto flex w-full max-w-content flex-col px-4 py-3">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `cursor-pointer rounded-md px-4 py-3 text-sm ${
                    isActive
                      ? 'bg-primary-50 font-medium text-primary-700'
                      : 'text-foreground-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}